module.exports = __webpack_public_path__ + "static/media/powered_by_stripe.0a03a27c.svg";